<div class="flex justify-between pl-4 mb-4">
  <h1>Agency Users</h1>
  <lib-button
    [cssType]="'btn-primary'"
    [icon]="'rightarrow'"
    [text]="'Add User'"
    [size]="'large'"
    (click)="addAgencyUser()"
  ></lib-button>
</div>
<lib-ui-grid class="pt-3" [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
